import React from "react";

interface IStep {
    key: string;
    label: string;
}

interface IProgressBar {
    currentStep: number;
    steps: IStep[];
    marginBottom?: string;
    isMenu?: boolean;
}

const ProgressBar = ({ currentStep, steps, marginBottom, isMenu }: IProgressBar) => {
    return (
        <div className={`py-2 ${marginBottom}`}>
            <ul className="d-flex align-items-center justify-content-center list-unstyled flex-wrap">
                {steps.map((step, index) => (
                    <React.Fragment key={`step-${index}`}>
                        <li className="text-grey fw-normal">
                            {isMenu ? (
                                <i
                                    className={`bi me-2 ${
                                        currentStep > index || currentStep === index
                                            ? "bi-check-circle-fill text-primary"
                                            : "bi-circle"
                                    } ${currentStep === index ? `text-primary` : ""}`}
                                ></i>
                            ) : (
                                <i
                                    className={`bi me-2 ${
                                        currentStep > index
                                            ? `bi-${index + 1}-circle-fill text-primary`
                                            : `bi-${index + 1}-circle`
                                    } ${currentStep === index ? `text-primary` : ""}`}
                                ></i>
                            )}

                            <p
                                className={`d-none d-lg-inline-block text-uppercase fs-7 mb-0 ${currentStep >= index ? "text-primary fw-bold" : ""}`}
                            >
                                {step.label}
                            </p>
                        </li>
                        {index < steps.length - 1 && (
                            <i
                                className={`bi bi-arrow-right mx-4 ${currentStep >= index ? "text-primary" : "text-grey"}`}
                            ></i>
                        )}
                    </React.Fragment>
                ))}
            </ul>
        </div>
    );
};

export default ProgressBar;
